module.exports = __webpack_public_path__ + "static/activityIcon4.35866d53.png";